module.exports = __webpack_public_path__ + "static/media/headerimage.a338e56c.jpg";